export enum CalendarEventView {
  Day = "day",
  Week = "week",
  WorkWeek = "work_week"
}
